import { Form, Formik } from "formik";
import AutoFocusError from "../components/AutoFocusError";
import { PropDetailsSchema, SellerStep1Schema } from "../validations";
import { useState } from "react";
import axios from "axios";
import { useLocation } from "react-router";
import FormFirstSlide from "../components/FormFirstSlide";
import MDSelectInput from "../components/Inputs/MDSelect";
import {
  financingOptions,
  interestedInOptions,
  propDetailsHelpOptions,
  propertyClassOptions,
  propTpriceRangeOptions,
  transactOptions,
} from "../utils/enum";
import MDTextInput from "../components/Inputs/MDTextInput";
import { toast } from "react-toastify";

const PropDealsForm = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const [isWhatsApp, setIsWhatsApp] = useState(false);
  const [currentStep, setCurrentStep] = useState(1);
  const [phoneBtnClick, setPhoneBtnClick] = useState(false);
  const [submitError, setSubmitError] = useState(false);
  const windowUrl = window.location.href;

  const marketingSource = queryParams.get("source");
  const initialValues = {
    name: "",
    email: "",
    phone: "",
    lookingfor: "",
    interestedIn: "",
    propertyClass: "",
    transact: "",
    priceRange: "",
    creativeFinancing: "",
    specificRequirements: "",
  };

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    setSubmitError(false);

    try {
      const data = {
        ...values,
        originUrl: windowUrl,
        formType: "PropTdeals",
        marketingSource: marketingSource || "",
      };
      const response = await axios.post(
        "https://config.needhome.ca/formconnector/sale2solddefault",
        data
      );
      if (response?.data?.result === 1) {
        setSubmitError(false);
        if (currentStep === 2) {
          window.scrollTo(0, 0);
          resetForm({ values: initialValues, submitCount: 0 });
          toast.success("Form submitted successfully!");
          setCurrentStep(1);
        } else {
          setCurrentStep(2);
          resetForm({ values, submitCount: 0 });
        }

        if (isWhatsApp) {
          window.open(
            `https://api.whatsapp.com/send?phone=16476490400&amp;text=Hey PropTdeals, My Name is ${
              values?.name || ""
            }. I am looking to Sell. Can you connect with me As soon as possible.`,
            "_blank"
          );
        }

        if (phoneBtnClick) {
          window.location.href = "tel:+16476490400";
        }
      } else {
        setSubmitError(true);
      }
    } catch (error) {
      setSubmitError(true);
      console.error(error);
    } finally {
      setIsWhatsApp(false);
      setPhoneBtnClick(false);
      setSubmitting(false);
    }
  };

  return (
    <>
      <div className="form_mainContainer">
        <div className="agent_profile d-flex align-items-center gap-3">
          <img
            src="https://config.assignmentsold.ca/Attachments/Newhomez-Agent-Profile.jpg"
            alt="Agent-Profle"
          />
          <div>
            <h3 className="agent_name m-0">{"PropTdeals"}</h3>
            <p className="agent_category">Off Market</p>
          </div>
        </div>
        <div className="form_container">
          <Formik
            initialValues={initialValues}
            validationSchema={
              currentStep === 1 ? SellerStep1Schema : PropDetailsSchema
            }
            onSubmit={handleSubmit}
          >
            {({
              isSubmitting,
              errors,
              handleChange,
              handleBlur,
              values,
              submitCount,
              submitForm,
            }) => (
              <Form className="w-100 gap-3 mt-4 d-flex flex-column">
                <AutoFocusError />
                {currentStep === 1 && (
                  <FormFirstSlide
                    values={values}
                    errors={errors}
                    submitCount={submitCount}
                    handleChange={handleChange}
                    handleBlur={handleBlur}
                    isMultiPartForm={true}
                    isPropTForm={true}
                  />
                )}

                {currentStep === 2 && (
                  <>
                    <div>
                      <p className="label_heading">
                        How can we help you with Real Estate?
                      </p>
                      <MDSelectInput
                        label="Select"
                        name="lookingfor"
                        value={values.lookingfor}
                        options={propDetailsHelpOptions}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={submitCount > 0 && Boolean(errors.lookingfor)}
                        helperText={submitCount > 0 && errors.lookingfor}
                        fullWidth
                      />
                    </div>

                    <div>
                      <p className="label_heading">
                        What kind of property are you interested in?
                      </p>
                      <MDSelectInput
                        label="Select"
                        name="interestedIn"
                        value={values.interestedIn}
                        options={interestedInOptions}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={submitCount > 0 && Boolean(errors.interestedIn)}
                        helperText={submitCount > 0 && errors.interestedIn}
                        fullWidth
                      />
                    </div>

                    <div>
                      <p className="label_heading">
                        Is there a class of property you are interested in?
                      </p>
                      <MDSelectInput
                        label="Select"
                        name="propertyClass"
                        value={values.propertyClass}
                        options={propertyClassOptions}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={submitCount > 0 && Boolean(errors.propertyClass)}
                        helperText={submitCount > 0 && errors.propertyClass}
                        fullWidth
                      />
                    </div>

                    <div>
                      <p className="label_heading">
                        How soon are you looking to transact?
                      </p>
                      <MDSelectInput
                        label="Select"
                        name="transact"
                        value={values.transact}
                        options={transactOptions}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={submitCount > 0 && Boolean(errors.transact)}
                        helperText={submitCount > 0 && errors.transact}
                        fullWidth
                      />
                    </div>

                    <div>
                      <p className="label_heading">
                        Do you have a price range in Mind?
                      </p>
                      <MDSelectInput
                        label="Select"
                        name="priceRange"
                        value={values.priceRange}
                        options={propTpriceRangeOptions}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={submitCount > 0 && Boolean(errors.priceRange)}
                        helperText={submitCount > 0 && errors.priceRange}
                        fullWidth
                      />
                    </div>

                    <div>
                      <p className="label_heading">
                        Have you secured your funding or are you looking for
                        creative financing options?
                      </p>
                      <MDSelectInput
                        label="Select"
                        name="creativeFinancing"
                        value={values.creativeFinancing}
                        options={financingOptions}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={
                          submitCount > 0 && Boolean(errors.creativeFinancing)
                        }
                        helperText={submitCount > 0 && errors.creativeFinancing}
                        fullWidth
                      />
                    </div>

                    <div>
                      <p className="label_heading">
                        Any other requirements or anything else you want us to
                        know about?
                      </p>
                      <MDTextInput
                        label="Enter here"
                        name="specificRequirements"
                        value={values.specificRequirements}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={
                          submitCount > 0 &&
                          Boolean(errors.specificRequirements)
                        }
                        helperText={
                          submitCount > 0 && errors.specificRequirements
                        }
                        fullWidth
                        multiline
                        rows={3}
                      />
                    </div>
                  </>
                )}

                {submitError && (
                  <p className="error_message m-0">
                    Error Submiting Form. Kindly submit again۔
                  </p>
                )}

                <div
                  className="w-100 d-flex align-item gap-3
                flex-wrap"
                >
                  <button
                    type="submit"
                    className={`submit_button next_button ${
                      isSubmitting ? "disabled_btn" : ""
                    }`}
                    disabled={isSubmitting}
                  >
                    {currentStep === 1 ? "Next" : "Submit"}
                  </button>

                  <button
                    type="button"
                    className={`submit_button call_button 
                         ${isSubmitting ? "disabled_btn" : ""}`}
                    disabled={isSubmitting}
                    onClick={() => {
                      submitForm();
                      setPhoneBtnClick(true);
                    }}
                  >
                    Call
                  </button>
                </div>

                <button
                  className={`Send_btn whatsApp_btn  ${
                    isSubmitting ? "disabled_btn" : ""
                  }`}
                  id="whatsApp_btn"
                  type="button"
                  disabled={isSubmitting}
                  onClick={() => {
                    setIsWhatsApp(true);
                    submitForm();
                  }}
                >
                  <img
                    src="https://config.assignmentsold.ca/attachments/newhomez-email/logos_whatsapp-icon.png"
                    alt="whatsapp_logo"
                  />
                  WhatsApp
                </button>

                <button
                  className={`Send_btn whatsApp_btn`}
                  type="button"
                  onClick={() => {
                    const link = document.createElement("a");
                    link.href = "/Talha_Chishti.vcf";
                    link.download = "Talha_Chishti.vcf";
                    link.click();
                  }}
                >
                  Save Contact
                </button>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </>
  );
};

export default PropDealsForm;
